import { ofType } from 'redux-observable';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { getCalenderEventsSummary } from 'actions/other';
import TRADE from 'actionTypes/trade';

const getOptionsExpiriesCalenderEventsEpic = action$ =>
  action$.pipe(
    ofType(TRADE.GET_OPTIONS_INFO.SUCCESS),
    map(action =>
      action.result.result
        .flatMap(item => item.data)
        .flatMap(item => item.settlement_time)
        .sort()
    ),
    filter(sortedExpiries => sortedExpiries.length),
    map((sortedExpiries: string[]) => ({
      startDate: sortedExpiries[0].substring(0, 10),
      endDate: sortedExpiries[sortedExpiries.length - 1].substring(0, 10),
    })),
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    map(({ startDate, endDate }) => {
      return getCalenderEventsSummary({
        startDate,
        endDate,
      });
    })
  );

export { getOptionsExpiriesCalenderEventsEpic };
